//Link to ceremony/courses
export const linkNormal = " text-blue hover:cursor-pointer hover:text-orange-dark group peer "
